<template>
  <div class="d-flex justify-content-between">
    <div>10</div>
    <div>11</div>
    <div>12</div>
    <div>13</div>
    <div>14</div>
    <div>15</div>
    <div>16</div>
    <div>17</div>
    <div>18</div>
  </div>
  <b-progress show-value :max="progressMax" class="mb-3 me-2 progressbar">
    <template v-for="(progress, index) in reserveProgressbar" :key="index" >
      <b-progress-bar :variant="progress.variant" :value="progress.value">{{ progress.label }}</b-progress-bar>
    </template>
  </b-progress>
</template>

<script>
import reserveMixin from '@/mixins/reserveMixin.js'

export default {
  name: 'ReserveProgress',
  props: {
    reservedTimes: { default: [] },
    enabled: { default: false },
    selectedDate: { default: "" },
  },

  data: () => ({
    progressMax: 450,
    //  プログレスバー用のデータ
    reserveProgressTimes: [
      { label: '10:00', value: 1000 }, { label: '10:15', value: 1015 }, { label: '10:30', value: 1030 }, { label: '10:45', value: 1045 },
      { label: '11:00', value: 1100 }, { label: '11:15', value: 1115 }, { label: '11:30', value: 1130 }, { label: '11:45', value: 1145 },
      { label: '12:00', value: 1200 }, { label: '12:15', value: 1215 }, { label: '12:30', value: 1230 }, { label: '12:45', value: 1245 },
      { label: '13:00', value: 1300 }, { label: '13:15', value: 1315 }, { label: '13:30', value: 1330 }, { label: '13:45', value: 1345 },
      { label: '14:00', value: 1400 }, { label: '14:15', value: 1415 }, { label: '14:30', value: 1430 }, { label: '14:45', value: 1445 },
      { label: '15:00', value: 1500 }, { label: '15:15', value: 1515 }, { label: '15:30', value: 1530 }, { label: '15:45', value: 1545 },
      { label: '16:00', value: 1600 }, { label: '16:15', value: 1615 }, { label: '16:30', value: 1630 }, { label: '16:45', value: 1645 },
      { label: '17:00', value: 1700 }, { label: '17:15', value: 1715 }, { label: '17:30', value: 1730 }, { label: '17:45', value: 1745 },
      { label: '18:00', value: 1800 },
    ],
  }),
  methods: {
    // 予約時間単位
    getReserveTimeUnit: function() {
      var timeUnit = 60;
      return timeUnit;
    },
  },
  computed: {
    reserveProgressbar: function() {
      // 無効の場合は空を返却
      if (!this.enabled) {
        return [];
      }
      var value = 0;
      var start = '';
      var end = '';
      var data = [];
      var revervedFlg = false;

      for (var time of this.reserveProgressTimes) {
        if (!start) {
          start = time;
        } else {
          value += 15;
        }
        end = time;
        for (var reservedTime of this.reservedTimes) {
          if (time.value < reservedTime.start || time.value > reservedTime.end) {
            continue;
          }
          else if (time.value == reservedTime.start) {
            if (value != 0) {
              // 予約可能時間が指定分より少ない場合は予約出来ないので予約済みとして扱う
              revervedFlg = (value < this.getReserveTimeUnit()) ? true : revervedFlg;
              data.push( {'start': start.label, 'end': end.label, 'value': value, 'reverved': revervedFlg});
            }
            start = time;
            value = 0;
            revervedFlg = true;
          }
          else if (time.value == reservedTime.end) {
            data.push( {'start': start.label, 'end': end.label, 'value': value, 'reverved': revervedFlg});
            start = time;
            value = 0;
            revervedFlg = false;
          }
        }
      }
      if (value != 0) {
        // 予約可能時間が指定分より少ない場合は予約出来ないので予約済みとして扱う
        revervedFlg = (value < this.getReserveTimeUnit()) ? true : revervedFlg;
        data.push( {'start': start.label, 'end': end.label, 'value': value, 'reverved': revervedFlg});
      }

      // 連続した予約済みデータを纏める
      var margeData = [];
      for (var i = 0; i < data.length; i++) {
        if (i != 0 && data[i].reverved && data[i - 1].reverved) {
          var margeDataSize = margeData.length - 1;
          margeData[margeDataSize].end = data[i].end;
          margeData[margeDataSize].value += data[i].value;
        } else {
          margeData.push(data[i]);
        }
      }

      var progressbar = [];
      margeData.forEach(ele => progressbar.push({ 'label': ele.reverved ? '✖' : '◯', 'value': ele.value, 'variant': ele.reverved ? 'secondary' : 'primary', }));
      // console.log(progressbar);
      return progressbar;
    },
  },
  mixins: [reserveMixin],
};
</script>
<style scoped>
.progressbar {
  height: 25px;
  font-size: initial;
}
</style>
